import React from 'react';
import { Search } from 'lucide-react';
import { empresaPapelOptions, empresaStatusOptions } from '../../../features/empresas/empresaForm';
import { EmpresaPapel, EmpresaStatus } from '../../../types/empresa';

interface Props {
  search: string;
  status: '' | EmpresaStatus;
  papel: '' | EmpresaPapel;
  disabled?: boolean;
  onSearchChange: (value: string) => void;
  onStatusChange: (value: '' | EmpresaStatus) => void;
  onPapelChange: (value: '' | EmpresaPapel) => void;
  onSubmit: () => void;
  onClear: () => void;
}

const CompanyFilters: React.FC<Props> = ({ search, status, papel, disabled, onSearchChange, onStatusChange, onPapelChange, onSubmit, onClear }) => (
  <form
    className="grid gap-3 rounded-xl border border-gray-200 bg-white p-4 md:grid-cols-[minmax(220px,1fr)_190px_220px_auto_auto]"
    onSubmit={(event) => { event.preventDefault(); onSubmit(); }}
  >
    <input aria-label="Buscar empresas" type="search" placeholder="CNPJ, razão social ou nome fantasia" value={search} onChange={(event) => onSearchChange(event.target.value)} className="rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-emerald-500 focus:outline-none focus:ring-2 focus:ring-emerald-100" />
    <select aria-label="Filtrar por status" value={status} onChange={(event) => onStatusChange(event.target.value as '' | EmpresaStatus)} className="rounded-lg border border-gray-300 px-3 py-2 text-sm">
      <option value="">Todos os status</option>
      {empresaStatusOptions.map((option) => <option key={option.value} value={option.value}>{option.label}</option>)}
    </select>
    <select aria-label="Filtrar por papel" value={papel} onChange={(event) => onPapelChange(event.target.value as '' | EmpresaPapel)} className="rounded-lg border border-gray-300 px-3 py-2 text-sm">
      <option value="">Todos os papéis</option>
      {empresaPapelOptions.map((option) => <option key={option.value} value={option.value}>{option.label}</option>)}
    </select>
    <button type="submit" disabled={disabled} className="inline-flex items-center justify-center gap-2 rounded-lg bg-emerald-600 px-4 py-2 text-sm font-medium text-white hover:bg-emerald-700 disabled:opacity-50"><Search size={16} /> Buscar</button>
    <button type="button" disabled={disabled} onClick={onClear} className="rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 disabled:opacity-50">Limpar</button>
  </form>
);

export default CompanyFilters;
